import { parse, stringify } from 'devalue';

export interface DataTransformer {
  deserialize: (input: unknown) => unknown;
  serialize: (object: unknown) => unknown;
}

export interface TransformerOptions {
  input: DataTransformer;
  output: DataTransformer;
}

type JsonPayload = { json: unknown };

const isJsonPayload = (value: unknown): value is JsonPayload => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  return 'json' in value;
};

const unwrapJsonPayload = (value: unknown): unknown => (isJsonPayload(value) ? value.json : value);

const devalueTransformer: DataTransformer = {
  serialize: (object) => stringify(object),
  deserialize: (input) => {
    const candidate = unwrapJsonPayload(input);
    if (typeof candidate === 'string') {
      return parse(candidate) as unknown;
    }
    return candidate;
  },
};

export const trpcTransformer: TransformerOptions = {
  input: devalueTransformer,
  output: devalueTransformer,
};

export const serializeDevalue = devalueTransformer.serialize;
export const deserializeDevalue = devalueTransformer.deserialize;
export const parseDevalue = devalueTransformer.deserialize;
export type { SweetisticsTrpcClient } from './client-types';
